import { windowWidth } from '../../../constants';

let winPrevScrPos = window.scrollY;

export const topbarOnScroll = () => {
  $(window).on('scroll', function () {
    let header =
      windowWidth < 1200
        ? $('.homepage-v3-topbar')
        : $('.homepage-v3-topbar-xl');
    const winCurrScrPos = window.scrollY;

    if (winCurrScrPos > 0) {
      if (winPrevScrPos <= winCurrScrPos) {
        header.addClass('scrolled');
      } else {
        header.removeClass('scrolled');
      }

      if (winCurrScrPos <= 0) {
        header.addClass('positioned-in-top');
      } else {
        header.removeClass('positioned-in-top');
      }
    } else {
      header.removeClass('scrolled');
      header.addClass('positioned-in-top');
    }

    winPrevScrPos = winCurrScrPos;
  });
};
